import { useState, useRef } from 'react';
import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import '../styles/home.css';
// Components
import Navbar from '../components/navbar';
import Footer from '../components/footer';

// Carga dinámica de archivos dentro de public/galeria usando Webpack
let galleryItems = [];

try {
  const galeriaContext = require.context(
    '../../public/galeria',
    false,
    /\.(png|jpe?g|webp|gif|mp4|webm|mov)$/i
  );

  galleryItems = galeriaContext.keys().map((key) => {
    const fileName = key.replace('./', '');
    const extension = fileName.split('.').pop().toLowerCase();
    const isVideo = ['mp4', 'webm', 'mov'].includes(extension);

    return {
      type: isVideo ? 'video' : 'image',
      src: `/galeria/${fileName}`,
      alt: 'Trabajo espiritual'
    };
  });
} catch (error) {
  console.warn('Asegúrate de que la carpeta public/galeria exista.', error);
}

function Home() {
  const [currentIndex, setCurrentIndex] = useState(0);
  // Estado para la imagen/video seleccionada para ver en grande
  const [selectedMedia, setSelectedMedia] = useState(null);

  const slideCarrousel = (direction) => {
    const limit = 9;
    if (direction === 'next') {
      setCurrentIndex(currentIndex === limit ? 0 : currentIndex + 1);
    } else {
      setCurrentIndex(currentIndex === 0 ? limit : currentIndex - 1);
    }
  };

  const videoSources = [
    { src: '/video/freda0777_1734791307028.mp4', id: 'video-0' },
    { src: '/video/ZhXvIF.mp4', id: 'video-2' },
    { src: '/video/sanmiguelvencio_1734572918185.mp4', id: 'video-1' },
  ];
  const videoSources2 = [
    { src: '/video/12367.mp4', id: 'video-3' },
    { src: '/video/haitianvodou_1742392688748.mp4', id: 'video-4' },
    { src: '/video/2356.mp4', id: 'video-6' },
    { src: '/video/6805.mp4', id: 'video-5' },
  ];

  const videoRefs = useRef([]);
  videoRefs.current = videoSources.map(
    (_, i) => videoRefs.current[i] ?? React.createRef()
  );

  const handlePlay = (currentIndex) => {
    videoRefs.current.forEach((ref, index) => {
      if (index !== currentIndex && ref.current) {
        ref.current.pause();
      }
    });
  };

  const sendWaMessage = (e) => {
    e.preventDefault();
    const name = e.target.nombre.value;
    const email = e.target.email.value;
    const message = e.target.mensaje.value;
    const phoneNumbers = ["+18294841919", "+18294841919", "+18294841919"];
    const randomIndex = Math.floor(Math.random() * phoneNumbers.length);
    const randomPhoneNumber = phoneNumbers[randomIndex];
    const waMessage = `Hola, soy ${name}. Mi correo es ${email}. ${message}`;
    const waUrl = `https://wa.me/${randomPhoneNumber}?text=${encodeURIComponent(waMessage)}`;
    window.open(waUrl, "_blank");
  };

  const carouselVariants = {
    enter: { opacity: 0, x: 100 },
    center: { opacity: 1, x: 0, transition: { duration: 0.5 } },
    exit: { opacity: 0, x: -100, transition: { duration: 0.5 } }
  };

  const sectionVariants = {
    Initial: { opacity: 0, y: 20 },
    animation: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.8 }
    },
  };

  return (
    <>
      <Navbar />

      <motion.section 
        className="banner" 
        id="inicio"
        initial="hidden"
        animate="visible"
        variants={sectionVariants}
      >
        <div className="banner-content">
          {videoSources.map((video, index) => (
            <motion.video
              key={video.id}
              width="640"
              height="360"
              controls
              ref={videoRefs.current[index]}
              onPlay={() => handlePlay(index)}
              className="banner-video"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1 }}
            >
              <source src={video.src} type="video/mp4" />
              Tu navegador no soporta la reproducción de videos.
            </motion.video>
          ))}
          <motion.h1 
            initial={{ y: -50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            Trabajos Espirituales Altamente Garantizados
          </motion.h1>
          <motion.p 
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Experiencia, compromiso y la magia ancestral al servicio de tu destino.
          </motion.p>
          <motion.a 
            href="#contacto"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            <motion.button 
              className="cta-button"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
            >
              Contáctame
            </motion.button>
          </motion.a>
        </div>
      </motion.section>

      <motion.section 
        className="sobre-mi" 
        id="sobre-mi"
        initial="hidden"
        animate="visible"
        variants={sectionVariants}
      >
        <div className="carousel-container">
          <div className="carousel" id="carousel">
            <AnimatePresence exitBeforeEnter>
              <motion.img
                key={currentIndex}
                src={`/images/carrousel/${currentIndex}.webp`}
                alt="carrousel"
                variants={carouselVariants}
                initial="enter"
                animate="center"
                exit="exit"
              />
            </AnimatePresence>
          </div>
          <motion.button 
            className="prev" 
            onClick={() => slideCarrousel('prev')}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            &#10094;
          </motion.button>
          <motion.button 
            className="next" 
            onClick={() => slideCarrousel('next')}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            &#10095;
          </motion.button>
        </div>

        <motion.h2
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          El Brujo
        </motion.h2>
        <motion.p 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          Con años de experiencia en rituales ancestrales, mi camino se ha forjado en la sabiduría de las antiguas tradiciones. Mi misión es guiarte hacia la transformación y el equilibrio espiritual.
        </motion.p>
        <br />
        <details>
          <summary style={{color: '#d4af37', cursor: 'pointer'}}>Más Videos...</summary>
          {videoSources2.map((video, index) => (
            <motion.video
              key={video.id}
              width="640"
              height="360"
              controls
              ref={videoRefs.current[index]}
              onPlay={() => handlePlay(index)}
              className="section-video"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1 }}
            >
              <source src={video.src} type="video/mp4" />
              Tu navegador no soporta la reproducción de videos.
            </motion.video>
          ))}
        </details>
      </motion.section>

      {/* Sección Galería Dinámica */}
      <motion.section 
        className="galeria" 
        id="galeria"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={sectionVariants}
      >
        <motion.h2>Galería de Trabajos</motion.h2>
        <div className="galeria-grid">
          {galleryItems.map((item, index) => (
            <motion.div 
              className="galeria-item" 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              onClick={() => setSelectedMedia(item)}
            >
              {item.type === 'video' ? (
                <video preload="metadata">
                  <source src={item.src} />
                  Tu navegador no soporta la reproducción de videos.
                </video>
              ) : (
                <img src={item.src} alt={item.alt || 'Galería'} />
              )}
            </motion.div>
          ))}
        </div>
      </motion.section>

      {/* MODAL LIGHTBOX (Aparece al dar clic en cualquier elemento de la galería) */}
      <AnimatePresence>
        {selectedMedia && (
          <motion.div 
            className="lightbox-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedMedia(null)}
          >
            <motion.div 
              className="lightbox-content"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              onClick={(e) => e.stopPropagation()}
            >
              <button 
                className="lightbox-close" 
                onClick={() => setSelectedMedia(null)}
              >
                &times;
              </button>

              {selectedMedia.type === 'video' ? (
                <video controls autoPlay className="lightbox-media">
                  <source src={selectedMedia.src} />
                </video>
              ) : (
                <img 
                  src={selectedMedia.src} 
                  alt={selectedMedia.alt || 'Galería'} 
                  className="lightbox-media" 
                />
              )}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.section 
        className="servicios" 
        id="servicios"
        initial="hidden"
        animate="visible"
        variants={sectionVariants}
      >
        <motion.h2>Servicios</motion.h2>
        <div className="service-container">
          {[
            { title: 'Lectura de Tarot', description: 'Descubre tu destino a través de cartas y símbolos, respaldado por rituales místicos.' },
            { title: 'Magia y Hechicería', description: 'Realizo trabajos mágicos altamente garantizados para transformar tu realidad.' },
            { title: 'Trabajos Espirituales', description: 'Rituales que conectan con la sabiduría de los ancestros para una sanación profunda.' },
            { title: 'Amarre de amor', description: 'Fortalece la conexión sentimental y atrae una unión genuina, utilizando rituales ancestrales que encienden la pasión y la fidelidad.' },
            { title: 'Suerte', description: 'Activa tus energías positivas y abre las puertas a la buena fortuna, mejorando cada aspecto de tu vida con vibraciones de prosperidad.' },
            { title: 'Pactos', description: 'Establece acuerdos místicos con fuerzas universales para alinear tu destino y desbloquear nuevos caminos hacia el éxito.' },
            { title: 'Sacrificios', description: 'Realiza ofrendas simbólicas para honrar a las deidades y transformar energías negativas en bendiciones y renovación espiritual.' },
            { title: 'Resguardos', description: 'Protege tu entorno y seres queridos con resguardos energéticos, diseñados para bloquear la negatividad y atraer vibraciones positivas.' },
            { title: 'Limpieza', description: 'Purifica tus espacios y tu ser mediante rituales de limpieza espiritual, eliminando bloqueos y renovando la armonía interior.' },
            { title: 'Liberación de Prisiones', description: 'A través de rituales místicos y energías espirituales, trabajamos para abrir caminos espirituales que faciliten la liberación de una persona encarcelada.' },
            { title: 'Números de Lotería', description: 'Mediante conexión con fuerzas superiores y técnicas de adivinación, revelamos los números con mayor potencial de atraer la fortuna en juegos de azar.' },
            { title: 'Viajes y mucho más', description: 'Asesoro y acompaño tus travesías, aplicando rituales de protección que te brindan seguridad y energía para descubrir nuevos horizontes.' },
          ].map((service, index) => (
            <motion.div 
              className="service"
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * .05}}
            >
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </motion.div>
          ))}
        </div>
      </motion.section>

      <motion.section 
        className="testimonios"
        initial="hidden"
        animate="visible"
        variants={sectionVariants}
      >
        <motion.h2>Testimonios</motion.h2>
        <hr />
        {[
          { text: '"Lo recomiendo es una persona muy fiable y responsable con sus clientes y trabajos. Me quería suicidar , pero le encontré a tiempo y me resolvió mis problemas.."', author: '- Leo Ronaldo' },
          { text: '"Lo recomiendo. Es fiable y cumple con su labor."', author: '- J J J J' },
        ].map((testimonial, index) => (
          <div key={index}>
            <motion.p
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.2 }}
            >
              {testimonial.text}
            </motion.p>
            <motion.small
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.4, delay: index * 0.2 + 0.1 }}
            >
              {testimonial.author}
            </motion.small>
            <hr />
          </div>
        ))}
        <br />
        <motion.a 
          href="https://g.co/kgs/2jEA9GJ"
          target="_blank"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.5 }}
        >
          Más reseñas...
        </motion.a>
      </motion.section>

      <motion.section 
        className="contacto" 
        id="contacto"
        initial="hidden"
        animate="visible"
        variants={sectionVariants}
      >
        <motion.h2>Contacto</motion.h2>
        <div className="contact-icons">
          <motion.a 
            href="https://wa.me/+18294841919" 
            target="_blank" 
            rel="noreferrer"
            whileHover={{ scale: 1.1 }}
          >
            WhatsApp
          </motion.a>
          <motion.a 
            href="https://www.instagram.com/hechicero_leo_dantor?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
            target="_blank"
            rel="noreferrer"
            whileHover={{ scale: 1.1 }}
          >
            Instagram
          </motion.a>
          <motion.a 
            href="https://www.facebook.com/share/1NKduCSiVf/?mibextid=wwXIfr"
            target="_blank"
            rel="noreferrer"
            whileHover={{ scale: 1.1 }}
          >
            Facebook
          </motion.a>
        </div>
        <form onSubmit={sendWaMessage}>
          <motion.input 
            type="text" 
            name="nombre" 
            placeholder="Tu nombre" 
            required
            whileFocus={{ scale: 1.05 }}
          />
          <motion.input 
            type="email" 
            name="email" 
            placeholder="Tu correo" 
            required
            whileFocus={{ scale: 1.05 }}
          />
          <motion.textarea 
            name="mensaje" 
            rows="5" 
            placeholder="Tu mensaje" 
            required 
            whileFocus={{ scale: 1.05 }}
          ></motion.textarea>
          <motion.button 
            type="submit"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Enviar Mensaje
          </motion.button>
        </form>
      </motion.section>

      <motion.section 
        className="ubicacion" 
        id="ubicacion"
        initial="hidden"
        animate="visible"
        variants={sectionVariants}
      >
        <motion.h2>Visitas</motion.h2>
        <iframe 
          title="Ubicación"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3786.210831901194!2d-70.0532913!3d18.3832533!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8ea55fac46edc18f%3A0x9d71d9b6a2ed6888!2sBrujo%20leo%20dantor%20oficial!5e0!3m2!1ses-419!2smx!4v1741933228282!5m2!1ses-419!2smx" 
          width="600" 
          height="450" 
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
        <motion.p>Dirección: San Gregorio de Nigua 91000, República Dominicana</motion.p>
        <motion.a 
          href="https://maps.app.goo.gl/suZT9u2aQrFVK1ceA" 
          target="_blank" 
          rel="noreferrer"
          whileHover={{ scale: 1.05 }}
        >
          <motion.button className="map-btn">Abrir en Google Maps</motion.button>
        </motion.a>
      </motion.section>

      <Footer />
    </>
  );
}

export default Home;